<template>
    <v-card>
        <v-card-title>{{$t('event.layouts')}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-form ref="form"
                        v-model="isFormValid">
                        <v-row>
                            <v-text-field outlined
                                        :label="$t('event_layout.style')"
                                        :placeholder="$t('event_layout.style')"
                                        type="number"
                                        v-model="eventLayout.style"></v-text-field>
                        </v-row>
                        <v-row>
                            <v-file-input accept="image/*"
                                        :label="$t('event_layout.banner') + ' ' + $t('event_layout.recommendedBannerSize')"
                                        v-model="eventLayout.banner"
                                        :rules="bannerRules">
                                <template v-slot:selection="{file}">
                                    <v-img :src="getFileUrl(file)"
                                        max-width="250px"
                                        max-height="250px"></v-img>
                                </template>
                            </v-file-input>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn color="primary" @click="saveEventLayout" :disabled="!isFormValid">
                                    {{$t('save')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref} from '@vue/composition-api'
    import {useGet} from "feathers-vuex";

    export default {
        name: 'EventLayout',
        setup(props, {root}) {
            const {Event} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const {item: event, isPending} = useGet({model: Event, id: eventId});

            const eventLayout = computed(() => {
                return event.value ? event.value.events_layout : null;
            });

            const bannerRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveEventLayout = async function () {
                try {
                    if (eventLayout.value.banner instanceof File) {
                        eventLayout.value.banner = {src: await root.$uploadFile(eventLayout.value.banner)};
                    }
                    if (!eventLayout.value.banner) {
                        eventLayout.value.banner = null;
                    }

                    eventLayout.value.save().then(()=>{
                        root.$store.dispatch('showSnackBar', root.$t('event_layout.save_successful'));
                    });
                } catch (e) {
                    root.$handleFeatherError(e);
                }
            };

            return {
                eventLayout,
                bannerRules,
                isFormValid,
                getFileUrl: root.$getFileURL,
                saveEventLayout,
            }
        },
    }
</script>